import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import PrivateRoute from './shared/components/PrivateRoute';
import ServerScreen from './screens/ServerScreen';
import AgentScreen from './screens/AgentScreen';
import LinksScreen from './screens/LinksScreen';
import Menu from './screens/Menu/Menu';
import useUserContext from './shared/hooks/useUserContext';

const { Sider, Content } = Layout;
// Screens
import {
  LoginScreen, PasswordScreen, SetupScreen
} from './screens';


const Routes = () => {
  const userConsumer = useUserContext();
  const { user } = userConsumer;
  const isLoggedIn = user && user.loggedIn;
  const showMenu = isLoggedIn && !user.passwordUpdateRequired;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {showMenu && (
        <Sider
          style={{
            height: '100vh',
            position: 'fixed',
            left: 0,
            zIndex: 5,
          }}
        >
          <Layout>
            <div className="logo" />
            <Menu />
          </Layout>
        </Sider>
      )}
      <Layout>
        <Content
          id="content"
          style={{
            minHeight: 280,
            marginLeft: showMenu ? '200px' : '0px',
          }}
        >
          <Switch>
            <Route path="/login" exact component={LoginScreen} />
            <Route path="/password" exact component={PasswordScreen} />
            <PrivateRoute path="/server" exact component={ServerScreen} />
            <PrivateRoute path="/agent" exact component={AgentScreen} />
            <PrivateRoute path="/setup" exact component={SetupScreen} />
            <PrivateRoute path="/resources" exact component={LinksScreen} />
            <PrivateRoute path="/" exact component={ServerScreen} />
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Routes;